export { PartitionStrategy } from './base';
